/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeploymentMetricDatapointDto
 */
export interface DeploymentMetricDatapointDto {
    /**
     * The timestamp when the metric has been collected.
     * @type {string}
     * @memberof DeploymentMetricDatapointDto
     */
    timestamp: string;
    /**
     * The collected values, for example { used: 4, total: 8 }.
     * @type {{ [key: string]: number; }}
     * @memberof DeploymentMetricDatapointDto
     */
    values: { [key: string]: number; };
}

/**
 * Check if a given object implements the DeploymentMetricDatapointDto interface.
 */
export function instanceOfDeploymentMetricDatapointDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function DeploymentMetricDatapointDtoFromJSON(json: any): DeploymentMetricDatapointDto {
    return DeploymentMetricDatapointDtoFromJSONTyped(json, false);
}

export function DeploymentMetricDatapointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentMetricDatapointDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'values': json['values'],
    };
}

export function DeploymentMetricDatapointDtoToJSON(value?: DeploymentMetricDatapointDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'values': value.values,
    };
}

